import { MailOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import React, { useCallback, useMemo } from "react";

const baseOptions = {
  centered: true,
  className: "dark-confirm-modal",
  width: 440,
};

const iconStyle = { fontSize: 22, marginTop: 2 };

export const useDarkConfirm = () => {
  const [modal, contextHolder] = Modal.useModal();

  const confirm = useCallback(
    (options) =>
      modal.confirm({
        ...baseOptions,
        icon: (
          <QuestionCircleOutlined style={{ ...iconStyle, color: "#818cf8" }} />
        ),
        ...options,
      }),
    [modal],
  );

  const confirmDanger = useCallback(
    (options) =>
      modal.confirm({
        ...baseOptions,
        icon: (
          <QuestionCircleOutlined style={{ ...iconStyle, color: "#f87171" }} />
        ),
        okButtonProps: { danger: true },
        ...options,
      }),
    [modal],
  );

  const confirmEmail = useCallback(
    (options) =>
      modal.confirm({
        ...baseOptions,
        icon: <MailOutlined style={{ ...iconStyle, color: "#38bdf8" }} />,
        okText: "Enviar",
        ...options,
      }),
    [modal],
  );

  return useMemo(
    () => ({ confirm, confirmDanger, confirmEmail, contextHolder }),
    [confirm, confirmDanger, confirmEmail, contextHolder],
  );
};
